<template>
  <UITable
    :columns="columns"
    :items="items"
    :loading="loading"
    :empty-text="emptyText"
    max-height="600px"
    @selection-change="$emit('selection-change', $event)"
  >
    <!-- Outbond ID Cell -->
    <template #cell(id)="{ item }">
      <div class="text-[14px]">
        {{ getOutboundCode(item) }}
      </div>
      <div
        v-b-tooltip.hover.top="getLabelFirstDownloadTooltip(item)"
        class="text-[12px] mt-[2px] font-normal"
      >
        {{ getLabelDownloadedText(item) }}
      </div>
    </template>

    <!-- Order Date Cell -->
    <template #cell(order_date)="{ item }">
      <div class="text-[14px]">
        {{ getFormattedDate(item) }}
      </div>
      <div class="text-[12px] mt-[2px] font-normal">
        {{ getFormattedTime(item) }}
      </div>
    </template>

    <!-- Status Cell -->
    <template #cell(status)="{ item }">
      <StatusPackingPill :status="item.status" />
    </template>

    <!-- Action Cell -->
    <template #cell(aksi)="{ item }">
      <router-link
        class="text-[#F95E16] font-medium hover:underline text-[14px]"
        :to="{ name: 'detail-fulfillment-kompack', query: { ref_id: item.id } }"
      >
        Lihat Detail
      </router-link>
    </template>

    <!-- Footer Slot for Infinite Scroll -->
    <template #footer>
      <LoadMoreProducts
        v-if="fetcher"
        :fetcher="fetcher"
        :show-all-loaded-text="false"
      />
    </template>
  </UITable>
</template>

<script>
import moment from 'moment'
import { Table as UITable } from '@/@core/components/ui'
import {
  DAY_WITH_FULL_DATE,
  TIME,
  TIME_DOT,
  DAY_FULL_DATE_TIME,
} from '@/libs/formatDate'
import { fieldsHistoryPacking } from '../../config'
import StatusPackingPill from './StatusPackingPill.vue'
import LoadMoreProducts from '../../../../komship/warehouse/LoadMoreProducts.vue'

export default {
  name: 'PackingHistoryTable',
  components: {
    UITable,
    StatusPackingPill,
    LoadMoreProducts,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    fetcher: {
      type: Object,
      default: null,
    },
    emptyText: {
      type: String,
      default: 'Tidak ada data yang dapat ditampilkan.',
    },
  },
  data() {
    return {
      columns: fieldsHistoryPacking.filter(col => col.key !== 'select'),
    }
  },
  methods: {
    getOutboundCode(item) {
      return item.outbound_code || item.outbound_no || item.id || '-'
    },
    /**
     * Formats the label download timestamp relative to current date.
     * @param {Object} item - Outbound history item.
     * @returns {string}
     */
    getLabelDownloadedText(item) {
      const timestamp = item.last_printed_at
      if (timestamp) {
        const formattedDate = moment(timestamp).isSame(moment(), 'day')
          ? TIME_DOT(timestamp)
          : DAY_FULL_DATE_TIME(timestamp)
        return `Label diunduh pada ${formattedDate}`
      }
      return 'Label belum diunduh'
    },
    getLabelFirstDownloadTooltip(item) {
      const timestamp = item.printed_at
      if (!timestamp) return ''
      return `Label pertama diunduh pada ${DAY_FULL_DATE_TIME(timestamp)}`
    },
    getFormattedDate(item) {
      if (!item.order_date && !item.created_at) return '-'
      return DAY_WITH_FULL_DATE(item.order_date || item.created_at)
    },
    getFormattedTime(item) {
      if (!item.order_date && !item.created_at) return '-'
      return TIME(item.order_date || item.created_at)
    },
  },
}
</script>
